import { isMyAppWKWebView } from "./isMyAppWKWebView";

/**
 * This function is called when the web app has loaded.
 * Once the LoadingPage has determined the user's state, it will call this function.
 */
export async function onLoaded() {
  if (window.Android) {
    return window.Android.onLoaded();
  }

  if (isMyAppWKWebView()) {
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    return (window.webkit as any).messageHandlers.onLoaded.postMessage(undefined);
  }

  return;
}
